import NumberInput from "../../inputs/NumberInput";
import TextInput from "../../inputs/TextInput";
import InputContainer from "./InputContainer"

const DropdownModalContent = ({ dropdownValue, setDropdownValue, position, setPosition }) => {
    return (
        <>
            <InputContainer>
                <TextInput
                    id="requirement-title"
                    placeholder="Enter Dropdown Value"
                    label='Dropdown Value'
                    value={dropdownValue}
                    setValue={(e) => setDropdownValue(e.target.value)}
                />
            </InputContainer>
            <InputContainer>
                <NumberInput
                    id="requirement-position"
                    label='Position'
                    min={0}
                    value={position}
                    setValue={(e) => setPosition(Number(e.target.value))}
                />
            </InputContainer>
        </>
    )
};

export default DropdownModalContent;